const {
    cloneDeep, assign, map, filter, unionBy, find, mapValues,
} = require('lodash');

const buttonState = {
    DEFAULT: 'DEFAULT',
    SAVED: 'SAVED',
};

class ProductSaveToListNewController {
    constructor($scope, $element, $state, $timeout, sessionStorage, analyticsService, savedListsService, shopperService, loginService, announcerService, moveFocus) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.sessionStorage = sessionStorage;
        this.analyticsService = analyticsService;
        this.savedListsService = savedListsService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.announcerService = announcerService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.showDropdown = false;
        this.buttonStates = buttonState;
        this.buttonState = buttonState.DEFAULT;
        this.pendingSaveToListStorageKey = `ProductSaveToListController:pendingSaveToList:${this.product.Stockcode}`;
        this.savedToLists = [];
        this.createListView = false;
        this.newListName = '';
        this.createListErrorMessage = '';

        this.errorFlags = {
            showListLoadError: false,
            showCreateListError: false,
        };

        this.getSavedLists().then(() => {
            if (!this.savedListsService.getIsServiceAvailable()) {
                this.showLoadListError();
            }
            this.savePendingProductToList();
            if (!this.shopperService.IsGuest) {
                this.savedListsService.getDefaultList().then((defaultList) => {
                    this.defaultListId = defaultList.ListId;
                });
            }
        });

        // Event listener for Saving Trolley as a list
        // This is needed when the user is on the Saved Lists page and the user adds a new list
        // This then needs to refresh the list of saved lists
        this.$scope.$on('savedLists:AddNewList', () => this.$timeout(() => this.getSavedLists()));
    }

    getSavedLists() {
        return this.savedListsService.getAllSavedLists().then((savedLists) => {
            this.savedLists = unionBy(this.savedToLists, map(cloneDeep(savedLists), list => assign(list, { isSelected: false })), 'ListId');
        });
    }

    savePendingProductToList() {
        if (this.shopperService.IsGuest) {
            return;
        }

        this.savedListsService.getAllSavedLists().then(() => {
            const { stockcode } = this.sessionStorage.getJsonAndRemove(this.pendingSaveToListStorageKey) || {};
            if (stockcode === this.product.Stockcode) {
                this.save();
                this.moveFocus(this.$element.find('._saveToListButton'));
            }
        });
    }

    save() {
        if (this.shopperService.IsGuest) {
            this.promptForGuest();
            return;
        }
        this.toggleDropdown(true, true);
    }

    saveToList(list, showDropdown) {
        this.savedListsService.getDefaultList().then((defaultList) => {
            this.buttonState = buttonState.SAVED;

            if (list.isSelected) {
                this.savedListsService.addListItem(list.ListId, this.product.Stockcode, this.product.DisplayQuantity, this.product.Source).then(() => {
                    this.announcerService.announce(`${this.product.Name} has been saved to ${list.ListId === defaultList.ListId ? 'Default' : list.Name}`);
                    this.toggleDropdown(showDropdown, false);
                    this.savedToLists = filter(this.savedLists, savedList => savedList.isSelected);
                });

                // push to tealium
                this.analyticsService.push({
                    data: {
                        trackingType: 'link',
                        list,
                        product: [this.product],
                    },
                    type: this.analyticsService.mapperTypes.customEvent.list.Add,
                });
            } else {
                this.savedListsService.deleteListItem(list.ListId, this.product.Stockcode).then(() => {
                    this.announcerService.announce(`${this.product.Name} has been deleted from ${list.ListId === defaultList.ListId ? 'Default' : list.Name}`);
                    this.toggleDropdown(showDropdown, false);
                    this.savedToLists = filter(this.savedLists, savedList => savedList.isSelected);
                });
            }
        });
    }

    resetErrorFlags() {
        this.errorFlags = mapValues(this.errorFlags, () => false);
    }

    showCreateListError() {
        this.resetErrorFlags();
        this.errorFlags.showCreateListError = true;
        this.focusError();
    }

    showLoadListError() {
        this.resetErrorFlags();
        this.errorFlags.showListLoadError = true;
        this.focusError();
    }

    focusError() {
        this.toggleDropdown(true);
        this.moveFocus(() => this.$element.find('._productSaveToListError'));
    }

    promptForGuest() {
        this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, () => {
            this.sessionStorage.setJson(this.pendingSaveToListStorageKey, { stockcode: this.product.Stockcode });
        });
    }

    toggleDropdown(showDropdown, shouldMoveFocus) {
        this.showDropdown = showDropdown;

        if (this.showDropdown && shouldMoveFocus) {
            this.moveFocus(() => this.$element.find('.productSaveToList-listItem > span').first());
            $('body').on('click.productSaveToList', e => this.closeDropdownOnOutsideClick(e));
        }
    }

    closeDropdownOnOutsideClick(event) {
        if (!($(event.target).closest('wow-product-save-to-list-new')[0] === this.$element[0])) {
            this.showDropdown = false;
            this.$scope.$apply();
            $('body').off(event);
        }
    }

    isDefaultList(listId) {
        return this.defaultListId === listId;
    }

    saveNewList() {
        if (!this.newListName.length) {
            return;
        }

        this.savedListsService.saveNewList(this.newListName.trim()).then(() => {
            this.getSavedLists().then(() => {
                this.announcerService.announce(`List ${this.newListName} has been created`);
                // save item to created list
                const newList = find(this.savedLists, { ListId: this.savedListsService.newListData.ListId });
                newList.isSelected = true;
                this.saveToList(newList, true);
                this.toggleCreateView(false);
            });
        }).catch((response) => {
            this.createListErrorMessage = response.Message;
            this.showCreateListError();
            this.analyticsService.pushError(response.Message);
        });
    }

    clearListName() {
        this.newListName = '';
    }

    toggleCreateView(showCreateView) {
        this.$timeout(() => {
            this.newListName = '';
            this.createListView = showCreateView;
            this.errorFlags.showCreateListError = false;
            const element = this.createListView
                ? '.productSaveToList-listItem > button'
                : '.productSaveToList-listItem > span';
            this.moveFocus(() => this.$element.find(element).first());
        });
    }

    $onDestroy() {
        $('body').off('click.productSaveToList');
    }
}

ProductSaveToListNewController.$inject = ['$scope', '$element', '$state', '$timeout', 'SessionStorageWrapper', 'AnalyticsService', 'SavedListsService', 'ShopperService', 'LoginService', 'AnnouncerService', 'MoveFocus'];

const productSaveToListNewComponentDefinition = {
    bindings: {
        product: '<',
        showLink: '<?',
        classModifier: '<?',
        showInline: '<?',
    },
    controller: ProductSaveToListNewController,
    template: require('./product-save-to-list-new.component.html').trim(),
};

module.exports = {
    ProductSaveToListNewController,
    productSaveToListNewComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/productsavetolist/product-save-to-list-new.component.js